import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Card } from "react-md";
import { MSpinner, SearchInstructions, MSplitter } from "../../components/Shared";
import { CaseHeader } from '../../components/Homeowner/CaseForms';
import { getCaseHeader, updateCaseHeader, getHistory } from '../../actions/homeowner/caseforms';
import MGrid, {
  ACTION_MAP,
  ACTION_DOWNLOAD,
  ACTION_CONFIGURE
} from "../../components/Shared/MGrid.tsx";
import { clearNullFromColumnDefs } from "../../components/Shared/Functions";
import { getCasePinURL } from '../../components/Shared/Map';

class SearchResult extends Component {
  constructor(props) {
    super(props);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.getMapPinForRow = this.getMapPinForRow.bind(this);
    this.state = {
      controlNumber: null
    };
  }

  handleRowClick(rowIdx) {
    const { user, getCaseHeader, getHistory } = this.props;
    let row = this.props.items.rows[rowIdx];
    if (row.locked === true) {
      return;
    }
    let pathname = "/case-profile";
    switch (row.rowType) {
      case "Broker":
        pathname = "/broker-case";
        break;
      case "Appraisal":
      case "MCaseView":
        pathname = "/case";
        break;
      case "Quality Review":
        pathname = "/bizops/case-view";
        break;
      case "Scheduling Assistant":
        pathname = "/scheduling-assistant/case-view";        
    }

    if (pathname === "/case-profile" && user.roles.some(r => ['MuellerCustomer', 'MuellerCustomerManager'].includes(r))) {
      getCaseHeader(row.controlIdNumber);
      getHistory(row.controlIdNumber);
      this.setState({
        controlNumber: row.controlIdNumber,
      });
      return;
    }

    this.props.history.push({
      pathname: pathname,
      state: { controlNumber: row.controlIdNumber }
    });
  }

  getMapPinForRow(i) {
    let row = this.props.items.rows[i];
    return {
      latitude: row.latitude,
      longitude: row.longitude,
      iconURL: getCasePinURL("red", false, false)
    };
  }

  render() {
    if (!this.props.isFetching && Object.keys(this.props.items).length === 0) {
      return <SearchInstructions />;
    }
    if (this.props.isFetching || Object.keys(this.props.items).length === 0) {
      return <MSpinner />;
    }
    
    const { getCaseHeader, updatingCaseHeader, updateCaseHeader, history } = this.props;
    const { controlNumber } = this.state;
    return (
      <MSplitter
        firstChild={
          <div className="padding-page-content full-height">
            <Card className="full-height">
              <MGrid
                configurationId="SearchGrid"
                headerText="Case List"
                columnDefinitions={clearNullFromColumnDefs(
                  this.props.items.columns
                )}
                data={this.props.items.rows}
                draggableColumns
                actions={[ACTION_MAP, ACTION_DOWNLOAD, ACTION_CONFIGURE]}
                onRowClick={this.handleRowClick}
                getMapPinForRow={this.getMapPinForRow}
              />
            </Card>
          </div>
        }
        secondChild={controlNumber &&
          <CaseHeader
            {...{ controlNumber, getCaseHeader, updatingCaseHeader, updateCaseHeader }}
            verticalDisplay
            showHistory
          />
        }
        secondChildTitle={{
          title: "Case Profile",
          buttons: [
            {
              icon: "fullscreen",
              onClick: () => history.push({
                pathname: ("/case"),
                state: { controlNumber }
              })
            },
            { icon: "close", onClick: () => this.setState({ controlNumber: null }) }
          ]
        }}
      />
    );
  }
}

SearchResult.propTypes = {
  history: PropTypes.object.isRequired,

  //Redux State
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.object.isRequired,
  user: PropTypes.object,
  updatingCaseHeader: PropTypes.bool,

  //Redux Actions
  getCaseHeader: PropTypes.func,
  updateCaseHeader: PropTypes.func,
  getHistory: PropTypes.func,

};
const mapStateToProps = state => {
  return {
    isFetching: state.search.isFetching,
    items: state.search.items,
    user: state.user.profile,
    updatingCaseHeader: state.caseForms.updatingCaseHeader,
  };
};

const mdtp = dispatch => ({
  getCaseHeader(caseId) {
    dispatch(getCaseHeader(caseId));
  },
  updateCaseHeader(controlNumber, dto) {
    dispatch(updateCaseHeader(controlNumber, dto));
  },
  getHistory(controlNumber) {
    dispatch(getHistory(controlNumber));
  },
});

export default withRouter(connect(mapStateToProps, mdtp)(SearchResult));
